import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import uni from "../../../assets/img/uni_logo.png";
import "./cardOnestyle.css";
import AOS from "aos";
import "aos/dist/aos.css";

const CardOne = () => {

  
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Stack direction="column" className="main-wrapper" data-aos="fade-up-right">
      <img
        src={uni}
        alt="img"
        style={{ maxHeight: "100px", maxWidth: "240px" }}
      />
      <div className="card-one-wrap">
        <Typography
          color="white"
          style={{
            fontFamily: "Titillium Web",
            fontWeight: "700",
            letterSpacing: "3px",
            maxWidth: "550px",
            fontSize: "22px",
          }}
        >
          Bachelor Of Science
        </Typography>
        <div>
          <Typography
            color="white"
            style={{
              fontFamily: "Titillium Web",
              fontWeight: "600",
              letterSpacing: "1px",
            }}
          >
            (Comupter Science & Mathematice 2019-2023)
          </Typography>
        </div>
        <div className="in-detail">
          <Typography
            color="white"
            style={{
              fontFamily: "Titillium Web",
              fontWeight: "500",
              letterSpacing: "1px",
            }}
          >
            Graduated from the University of Ruhuna with a specialization in
            Computer Science and Mathematics.
          </Typography>
        </div>
      </div>
    </Stack>
  );
};

export default CardOne;
